.biz-solutions {
  width: 100%;
  overflow: clip;
  padding: clamp(42px, 4vw, 58px) clamp(20px, 5vw, 76px);
  background: #faf8f7;
  color: #222222;
}

.biz-solutions__inner {
  width: 100%;
  max-width: 1440px;
  margin-inline: auto;
}

.biz-intro {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(280px, 0.75fr);
  align-items: start;
  gap: clamp(24px, 3vw, 44px);
  margin-bottom: clamp(34px, 4vw, 52px);
}

.biz-intro__main {
  min-width: 0;
}

.biz-intro__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #686562;
  font-family: "DM Sans", sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.13em;
  line-height: 1.4;
}

.biz-intro__dot {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #ff6b00;
}

.biz-intro__title {
  margin: 20px 0 0;
  color: #222222;
  font-family: "Sora", sans-serif;
  font-size: clamp(38px, 4.2vw, 66px);
  font-weight: 600;
  letter-spacing: -0.065em;
  line-height: 1.05;
}

.biz-line-wrap {
  display: block;
  overflow: hidden;
  padding-bottom: 0.08em;
  perspective: 700px;
}

.biz-line {
  display: block;
  transform-origin: 50% 100%;
}

.biz-intro__title em {
  color: #ff6b00;
  font-style: normal;
}

.biz-intro__description {
  max-width: 470px;
  margin: 45px 0 0 auto;
  color: #62615f;
  font-family: "DM Sans", sans-serif;
  font-size: clamp(14px, 1.08vw, 16px);
  font-weight: 400;
  line-height: 1.8;
}

.biz-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.biz-card {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e8e4e1;
  border-radius: 6px;
  background: #222222;
  color: inherit;
  text-decoration: none;
  transition:
    border-color 0.3s ease,
    box-shadow 0.35s ease,
    transform 0.4s cubic-bezier(0.2, 0.75, 0.25, 1);
}

.biz-card:hover {
  transform: translateY(-4px);
  border-color: rgb(255 107 0 / 42%);
  box-shadow: 0 16px 36px rgb(25 22 20 / 16%);
}

.biz-card:focus-visible {
  outline: 2px solid #ff6b00;
  outline-offset: 4px;
}

.biz-card__image-wrap {
  position: relative;
  width: 100%;
  height: clamp(225px, 21vw, 270px);
  overflow: hidden;
  border-radius: inherit;
  background: #eae8e5;
  isolation: isolate;
}

.biz-card__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.001);
  transition:
    transform 0.9s cubic-bezier(0.2, 0.75, 0.25, 1),
    filter 0.6s ease;
}

.biz-card:hover .biz-card__image {
  transform: scale(1.055);
}

.biz-card__image-shade {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgb(0 0 0 / 3%) 0%,
    rgb(0 0 0 / 0%) 28%,
    rgb(0 0 0 / 34%) 52%,
    rgb(0 0 0 / 82%) 78%,
    rgb(0 0 0 / 94%) 100%
  );
  transition: opacity 0.35s ease;
}

.biz-card:hover .biz-card__image-shade {
  opacity: 0.96;
}

.biz-card__image-arrow {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 3;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid rgb(255 255 255 / 60%);
  border-radius: 5px;
  background: rgb(255 255 255 / 88%);
  color: #222222;
  opacity: 0;
  transform: translate(-5px, 5px) rotate(-20deg);
  transition:
    opacity 0.3s ease,
    transform 0.4s cubic-bezier(0.2, 0.75, 0.25, 1);
}

.biz-card:hover .biz-card__image-arrow {
  opacity: 1;
  transform: translate(0, 0) rotate(0);
}

.biz-card__overlay {
  position: absolute;
  inset: auto 0 0;
  z-index: 2;
  display: flex;
  height: 58%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0;
  padding: 14px 14px 13px;
  color: #ffffff;
}

.biz-card__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.biz-card__copy h3 {
  align-self: flex-start;
  margin: 0;
  color: #ffffff;
  font-family: "Sora", sans-serif;
  font-size: clamp(13px, 1.12vw, 17px);
  font-weight: 550;
  letter-spacing: -0.035em;
  line-height: 1.35;
  text-shadow: 0 1px 12px rgb(0 0 0 / 28%);
}

.biz-card__copy p {
  display: -webkit-box;
  max-width: 570px;
  margin: 0;
  overflow: hidden;
  color: rgb(255 255 255 / 86%);
  font-family: "DM Sans", sans-serif;
  font-size: clamp(12px, 0.9vw, 14px);
  line-height: 1.45;
  text-shadow: 0 1px 10px rgb(0 0 0 / 38%);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.biz-card__link {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  align-self: flex-start;
  gap: 6px;
  margin-top: 8px;
  color: #ff8a35;
  font-family: "DM Sans", sans-serif;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.3;
  transition: color 0.25s ease;
}

.biz-card__link:hover {
  color: #ffb06f;
}

.biz-card__link svg {
  transition: transform 0.3s ease;
}

.biz-card:hover .biz-card__link svg {
  transform: translate(3px, -3px);
}

@media (max-width: 1050px) {
  .biz-solutions {
    padding-block: 48px;
  }

  .biz-intro {
    grid-template-columns: minmax(0, 1.1fr) minmax(250px, 0.8fr);
    margin-bottom: 38px;
  }

  .biz-intro__description {
    margin-top: 42px;
  }

  .biz-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
}

@media (max-width: 760px) {
  .biz-solutions {
    padding-block: 42px;
  }

  .biz-intro {
    grid-template-columns: 1fr;
    margin-bottom: 34px;
  }

  .biz-intro__eyebrow {
    font-size: 10px;
    letter-spacing: 0.12em;
  }

  .biz-intro__title {
    margin-top: 14px;
    font-size: clamp(30px, 6.6vw, 44px);
    letter-spacing: -0.055em;
    line-height: 1.12;
  }

  .biz-intro__description {
    max-width: 600px;
    margin: 0;
    font-size: 13.5px;
    line-height: 1.7;
  }

  .biz-card__image-wrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: auto;
    min-height: 260px;
  }

  .biz-card__image {
    position: absolute;
    inset: 0;
  }

  .biz-card__overlay {
    position: relative;
    inset: auto;
    height: auto;
    gap: 10px;
    padding: 56px 14px 14px;
  }

  .biz-card__copy {
    display: block;
  }

  .biz-card__copy h3 {
    font-size: clamp(14px, 4vw, 16px);
    line-height: 1.3;
  }

  .biz-card__copy p {
    margin: 6px 0 0;
    font-size: clamp(12px, 3.3vw, 13px);
    line-height: 1.5;
  }

  .biz-card__link {
    margin-top: 2px;
  }
}

@media (max-width: 520px) {
  .biz-solutions {
    padding: 36px 18px;
  }

  .biz-intro {
    gap: 12px;
    margin-bottom: 28px;
  }

  .biz-intro__title {
    font-size: clamp(27px, 7.6vw, 33px);
    letter-spacing: -0.05em;
    line-height: 1.14;
  }

  .biz-intro__description {
    font-size: 13px;
    line-height: 1.65;
  }

  .biz-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .biz-card__image-wrap {
    min-height: 260px;
  }

  .biz-card__overlay {
    gap: 8px;
    padding: 52px 14px 14px;
  }

  .biz-card__copy h3 {
    font-size: 15px;
  }

  .biz-card__copy p {
    margin-top: 5px;
    font-size: 12.5px;
  }

  .biz-card__link {
    font-size: 11.5px;
  }

  .biz-card__image-arrow {
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    opacity: 1;
    transform: none;
  }
}

@media (max-width: 360px) {
  .biz-intro__title {
    font-size: 26px;
  }

  .biz-card__image-wrap {
    min-height: 250px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .biz-card,
  .biz-card__image,
  .biz-card__image-arrow,
  .biz-card__link svg {
    transition: none !important;
  }
}
